
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8UOfb", function(module, exports) {
module.exports = JSON.parse('{"frozen-columns-onboarding.spotlight.body":"Ordene, congele e redimensione tickets com um \xfanico controle.","frozen-columns-onboarding.spotlight.dismiss":"OK","frozen-columns-onboarding.spotlight.heading":"Gerencie tickets","jira-nin-group-by-any-field-changeboarding.spotlight.body":"Agrupe tickets por campos, incluindo vers\xf5es, etiquetas, tipos de ticket e muito mais.","jira-nin-group-by-any-field-changeboarding.spotlight.dismiss":"OK","jira-nin-group-by-any-field-changeboarding.spotlight.heading":"Agrupe tickets para se manter organizado"}');

});


//# sourceMappingURL=pt-BR.84fef46b.js.map
